import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {LinearProgress} from '@mui/material';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
//import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const businessTypeList = [
  'Wholesaler',
  'Manufacturer',
  'Exporter',
  'Importer',
  'Retailer',
  'Service'
];

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  //const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  //const [pageLoading, setPageLoading] = React.useState(false);

  const [businessTypes, setBusinessTypes] = React.useState(['Wholesaler']);  
  const [productTitle, setProductTitle] = React.useState("");
  const [productShortDesc, setProductShortDesc] = React.useState("");
  const [price, setPrice] = React.useState(0);

  const [contentFilePath, setContentFilePath] = React.useState("");
  const [currentFile, setCurrentFile] = React.useState("");

  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  const handleBusinessType = (event) => {
    const {
      target: { value },
    } = event;
    setBusinessTypes(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };


  React.useEffect(() => {	
    if(open && props.dataObj && props.dataObj.autoId){
      setProductTitle(props.dataObj.productTitle);
      setProductShortDesc(props.dataObj.productShortDesc);
      setPrice(props.dataObj.price);
      setCurrentFile(props.dataObj.image);
      if(props.dataObj.businessTypes && props.dataObj.businessTypes.length>0){
        setBusinessTypes(props.dataObj.businessTypes.split(","));
      }else{
        setBusinessTypes([]);  
      }

    }else{
      setProductTitle("");
      setProductShortDesc("");
      setPrice(0);
      setCurrentFile("");
      setBusinessTypes(['Wholesaler']);

    }
	}, [props.dataObj,open]);



	function saveData(){
    if(!productTitle){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter product title");			
      return false;
    }
    if(!productShortDesc){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter product short description");			
      return false;
    }
    if(!businessTypes){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select business types");			
      return false;
    }
    
		if(productTitle && productTitle.length>1){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('initialUrl', props.initialUrl);
      data.append('productTitle', productTitle);
      data.append('productShortDesc', productShortDesc);

      data.append('businessTypes', businessTypes);
      
      data.append('currentFile', currentFile);
      var myContentFile = document.querySelector('#contentfile');
      if(myContentFile.files[0]){
        data.append("uploadedFiles", myContentFile.files[0]);
      }

      if(price && price>0){
        data.append('price', price);
      }else{
        data.append('price', 0);
      }
      
      let apiURL='/create-product-free';
      let myMessage="Product has been created.";
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/update-product-free';
          myMessage="Product has been updated.";
      }
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){          
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This company name was created earlier. Kindly enter another company name.");
            return false;  					

        }else if(response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("It could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  // function nameOnly(event) {
  //   if (!/[a-z ]/i.test(event.key)) {
  //     event.preventDefault();
  //     return false;
  //   }
  // }

  function numberOnly(event) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>}</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Product Title' onChange={event => setProductTitle(event.target.value)} value={productTitle} placeholder={'Enter product title'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Product Short Description' onChange={event => setProductShortDesc(event.target.value)} value={productShortDesc} placeholder={'Enter product short description'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                                  <FormControl size='small' sx={{width: '100%' }}>
                                      <InputLabel id="demo-multiple-checkbox-label">Business Type</InputLabel>
                                      <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        value={businessTypes}
                                        onChange={handleBusinessType}
                                        input={<OutlinedInput label="Business Type" />}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}                                        
                                      >
                                        {businessTypeList.map((name) => (
                                          <MenuItem key={name} value={name}>
                                            <Checkbox checked={businessTypes.includes(name)} />
                                            <ListItemText primary={name} />
                                          </MenuItem>
                                        ))}
                                      </Select>
                                </FormControl>
                            </td>                            
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Price' onChange={event => setPrice(event.target.value)} value={price} placeholder={'Enter price'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>
                                <input 
                                  style={{ display: 'none' }}
                                  id="contentfile"
                                  type="file" 
                                  onChange={event => setContentFilePath(event.target.value)}
                                />
                                <label htmlFor="contentfile">
                                  <Button component="span" style={{backgroundColor:'#f9c07a',color:'#000', margin: 2}} size="small" variant="contained" >
                                    Browse Image
                                  </Button>   
                                  {
                                    (contentFilePath && contentFilePath!==null)?
                                    <span style={{marginLeft:5}}>{contentFilePath}</span>
                                    :null
                                  }                         
                                </label>

                              </td>                            
                        </tr>

                      </table>
                      
                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;